<template>
  <div>
    <div class="list">
      <div class="navs">
        <el-tabs class="nav" v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="全部" name="first">
            <lists></lists>
          </el-tab-pane>
          <el-tab-pane label="回头客" name="second">
            <lists></lists>
          </el-tab-pane>
          <el-tab-pane label="弃单" name="third">
            <lists></lists>
          </el-tab-pane>
          <el-tab-pane label="电子订阅" name="fourth">
            <lists></lists>
          </el-tab-pane>
        </el-tabs>
        <div class="excel">
          <el-button type="primary" size="mini">导入</el-button>
          <el-button type="primary" size="mini">导出</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import lists from "./components/lists";
export default {
  data() {
    return {
      activeName: "first"
    };
  },
  methods: {
    handleClick(tab, event) {}
  },
  components: {
    lists
  }
};
</script>

<style lang="less" scoped>
.list {
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(235, 237, 248, 1);
  .navs {
    position: relative;
  }
  .nav {
    flex: 1;
    /deep/ .el-tabs__nav-scroll {
      padding: 0 20px;
    }
  }
  .excel {
    height: 38px;
    line-height: 38px;
    border-bottom: 1.5px solid #e4e7ed;
    color: #0077ff;
    padding-right: 10px;
    position: absolute;
    top: 0;
    right: 0;
    > span {
      margin: 0 10px;
      &:hover {
        cursor: pointer;
      }
    }
  }
}
</style>